module.exports = __webpack_public_path__ + "static/media/2000d.4afa4ce8.jpg";